import { render, staticRenderFns } from "./AccountLocked.vue?vue&type=template&id=736a1e99&scoped=true&"
import script from "./AccountLocked.vue?vue&type=script&lang=js&"
export * from "./AccountLocked.vue?vue&type=script&lang=js&"
import style0 from "./AccountLocked.vue?vue&type=style&index=0&id=736a1e99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736a1e99",
  null
  
)

export default component.exports